import React, { useEffect, useState } from 'react';
import Compressor from 'compressorjs';
import axios from 'axios';

const useThumbnailHandleS3 = (file = null, upKey = null, delKey = null) => {
  const [thumbProgress, setProgress] = useState(0);
  const [thumbImageUrl, setFileUrl] = useState('');
  const [thumbImageKey, setFileKey] = useState('');
  const [uploadFile, setUploadFile] = useState(null);
  const [deleteFileKey, setDeleteFile] = useState(null);

  useEffect(() => {
    setUploadFile(file);
    setDeleteFile(delKey);
    setProgress(0);
  }, [file, delKey]);

  // 🔴 Delete from backend
  const handleDelete = async (key) => {
    try {
      await axios.post('/api/delete-image', { key });
      console.log('Thumbnail deleted:', key);
    } catch (err) {
      console.error('Failed to delete thumbnail:', err);
    }
  };

  if (deleteFileKey) {
    handleDelete(deleteFileKey);
    setDeleteFile(null);
    setFileUrl('');
  }

  // 🟢 Upload thumbnail via Laravel backend
  const handleUpload = (file) => {
    const extension = file.name.split('.').pop();
    const fileName = `${Date.now()}.${extension}`;

    new Compressor(file, {
      quality: 0.6,
      maxWidth: 900,
      maxHeight: 454,
      success: async (compressedFile) => {
        const fData = new FormData();
        fData.append('image', compressedFile);
        fData.append('filePath', upKey + '/');
        fData.append('content_type', compressedFile.type);

        try {
          const response = await axios.post('/api/upload-image', fData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: (evt) => {
              const progressPercentage = parseInt((evt.loaded * 100) / evt.total);
              setProgress(progressPercentage);
            },
          });

          if (response?.data?.url) {
            setFileUrl(response.data.url);
            setFileKey(response.data.Key);
            setProgress(100);
          }
        } catch (err) {
          console.error('Thumbnail upload failed:', err);
        }
      },
      error: (err) => {
        console.error('Thumbnail compression failed:', err);
      },
    });
  };

  if (uploadFile) {
    handleUpload(uploadFile);
    setUploadFile(null);
  }

  return [thumbImageUrl, thumbImageKey, thumbProgress];
};

export default useThumbnailHandleS3;
